export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "Włącz wiadomości OTA",
    installIntro:
      "Aby odpowiadać gościom z Booking.com / Airbnb z poziomu WA Checkin, trzeba zainstalować aplikację",
    installIntroTail: "w danym obiekcie.",
    installBtn: "Zainstaluj wiadomości OTA",
    installing: "Instalowanie modułu wiadomości…",
    retryLink: "Aplikacja jest już zainstalowana, sprawdź ponownie",
    loading: "Wczytywanie wiadomości OTA…",
    empty: "Brak wiadomości OTA dla tej rezerwacji.",
    modeAi: "AI",
    modeManual: "Ręczny",
    predefinedHeader: "Szybkie odpowiedzi",
    predefinedEmpty: "Brak pasujących odpowiedzi.",
    inputPlaceholder: "Proszę wpisać wiadomość albo użyć / do szybkich odpowiedzi...",
    attachTitle: "Dołącz obraz",
    senderGuest: "Gość",
    senderProperty: "Obiekt",
    senderSystem: "System",
    senderUnknown: "Nieznany",
    fileFallback: "plik",
    toastTitle: "Wiadomości OTA",
    errorTitle: "Błąd",
    loadError: "Nie udało się wczytać wiadomości OTA.",
    modeErrorDetail: "Nie udało się zidentyfikować czatu OTA. Proszę odświeżyć stronę.",
    modeManualOnTitle: "Tryb ręczny włączony",
    modeAiOnTitle: "Agent AI włączony",
    modeManualOnDetail: "Odpowiedzi na wiadomości będą wysyłane ręcznie",
    modeAiOnDetail: "Bot będzie odpowiadał automatycznie",
    modeChangeError: "Nie udało się zmienić trybu czatu OTA",
    sendError: "Nie udało się wysłać wiadomości OTA.",
    onlyImagesTitle: "Tylko obrazy",
    onlyImagesDetail: "OTA pozwalają wysyłać wyłącznie obrazy.",
    imageTooBigTitle: "Obraz za duży",
    imageTooBigDetail: "Obraz nie może przekraczać 5 MB.",
    installNoProperty: "Nie znaleziono obiektu podłączonego do Channex.",
    installOk: "Aplikacja zainstalowana pomyślnie.",
    installError: "Nie udało się zainstalować aplikacji.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "Proszę wpisać notatkę wewnętrzną…",
    saveHint: "⌘ / Ctrl + Enter, aby zapisać",
    saving: "Zapisywanie…",
    addNote: "Dodaj notatkę",
    loading: "Wczytywanie notatek…",
    emptyTitle: "Brak notatek",
    emptyText: "Pierwszą notatkę wewnętrzną można dodać w polu powyżej.",
    cancel: "Anuluj",
    save: "Zapisz",
    team: "Zespół",
    confirmDelete: "Usunąć?",
    yes: "Tak",
    no: "Nie",
    editTitle: "Edytuj",
    deleteTitle: "Usuń",
    loadError: "Nie udało się wczytać notatek",
    added: "Notatka dodana",
    saveError: "Nie udało się zapisać notatki",
    updated: "Notatka zaktualizowana",
    updateError: "Nie udało się zaktualizować notatki",
    deleted: "Notatka usunięta",
    deleteError: "Nie udało się usunąć notatki",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "Do zapłaty",
    paidLabel: "Pobrane",
    totalLabel: "Razem",
    loading: "Wczytywanie płatności…",
    empty: "Nie zarejestrowano jeszcze żadnej płatności.",
    addPayment: "Dodaj płatność…",
    fullyPaid: "Rezerwacja opłacona w całości",
    recalcTitle: "Przelicz ponownie",
    sendWhatsappTitle: "Wyślij przez WhatsApp",
    copyLinkTitle: "Kopiuj link",
    editAction: "Edytuj",
    deleteAction: "Usuń",
    modalEditTitle: "Edytuj płatność",
    modalAddTitle: "Dodaj płatność",
    amountLabel: "Kwota do pobrania",
    fillRemaining: "Pobierz resztę ({amount})",
    methodLabel: "Metoda płatności",
    sendWhatsappCheck: "Wyślij gościowi link przez WhatsApp",
    noteLabel: "Notatka (opcjonalnie)",
    notePlaceholder: "Np. zadatek, płatność po przyjeździe…",
    cancel: "Anuluj",
    save: "Zapisz",
    generateLink: "Wygeneruj link",
    registerPayment: "Zarejestruj płatność",
    deleteConfirmTitle: "Usunąć tę płatność?",
    deleteText1: "Spowoduje to usunięcie płatności na kwotę",
    deleteLinkVoided: "Link do płatności zostanie unieważniony.",
    deleteIrreversible: "Tej operacji nie da się cofnąć.",
    deleteBtn: "Usuń płatność",
    sendConfirmTitle: "Wysłać link do płatności?",
    sendText1: "Gość dostanie przez WhatsApp link do zapłaty kwoty",
    sendBtn: "Wyślij link",
    methodCash: "Gotówka",
    methodCard: "Karta / terminal",
    methodTransfer: "Przelew bankowy",
    methodOta: "Opłacone przez OTA",
    statusPaid: "Pobrane",
    statusPending: "Oczekuje",
    statusFailed: "Nieudane",
    statusCancelled: "Anulowane",
    loadError: "Nie udało się wczytać płatności.",
    amountRequired: "Proszę podać kwotę.",
    saveError: "Nie udało się zapisać płatności.",
    deleteError: "Nie udało się usunąć.",
    sendLinkError: "Nie udało się wysłać linku.",
    recalcError: "Nie udało się przeliczyć ponownie.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "Przypisz pokój",
    subWithUnitPre: "Ta rezerwacja w jednostce",
    subWithUnitPost: "nie ma jeszcze przypisanego pokoju fizycznego.",
    subNoUnit: "Ta rezerwacja nie ma jeszcze przypisanego pokoju fizycznego.",
    loading: "Sprawdzanie dostępności…",
    freePre: "Wolne pokoje",
    freePost: "Wystarczy wybrać jeden i przypisać go od razu:",
    freeBadge: "Wolny",
    assigning: "Przypisywanie…",
    occupiedNote:
      "{count} pokój zajęty w tych terminach | {count} pokoje zajęte w tych terminach | {count} pokoi zajętych w tych terminach",
    noneFreeTitle: "Brak wolnych pokoi w tych terminach.",
    noFreePre: "Wszystkie pokoje",
    thisType: "tego typu",
    noFreeMid:
      "są zajęte lub zablokowane {date}. Aby przypisać tę rezerwację, trzeba",
    reorganizeBold: "przeorganizować rezerwacje",
    noFreeMid2: "dla tego typu pokoju w kalendarzu (przycisk",
    organizeBtn: "Organizuj",
    noFreeTail: "), aby zwolnić jeden z nich.",
    tagMaintenance: "Konserwacja",
    tagBlocked: "Zablokowany",
    theseDates: "w tych terminach",
    occupied: "Zajęty",
    assignedOk: "Pokój {label} został przypisany.",
    assignError: "Nie udało się przypisać pokoju.",
    notifyError: "Błąd",
    notifyDone: "Gotowe",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "Pokoje w tej rezerwacji",
    typesCount: "{count} typ | {count} typy | {count} typów",
    roomsCount: "{count} pokój | {count} pokoje | {count} pokoi",
    guestsCount: "{count} gość | {count} goście | {count} gości",
    totalLabel: "Razem",
    viewingBadge: "Podgląd",
    noRoomAssigned: "Brak przypisanego pokoju",
    removeOneRoom: "Usuń jeden pokój",
    addOneRoom: "Dodaj jeden pokój",
    confirmRemove: "Usunąć?",
    yes: "Tak",
    no: "Nie",
    cannotRemoveOnly: "Nie można usunąć jedynego pokoju",
    removeRoomFromBooking: "Usuń ten pokój z rezerwacji",
    updating: "Aktualizowanie…",
    theChannel: "kanał",
    otaManaged:
      "Tym pokojem zarządza {channel}: ilość i cenę zmienia się tam.",
    notifyError: "Błąd",
    notifyDone: "Gotowe",
    qtyUpdated: "Ilość zaktualizowana",
    roomRemoved: "Pokój usunięty z rezerwacji",
    updateError: "Nie udało się zaktualizować rezerwacji. Proszę spróbować ponownie.",
  },
};
